export var AiResultType;
(function (AiResultType) {
    AiResultType["TIME_SERIES_RESULT"] = "time_series_chart";
    AiResultType["VERTICAL_BAR_RESULT"] = "vertical_bar_chart";
    AiResultType["ONE_LINE_RESULT"] = "one_line_result";
    AiResultType["TABLE_RESULT"] = "table";
})(AiResultType || (AiResultType = {}));
//# sourceMappingURL=types.js.map